export default __webpack_public_path__ + "static/media/song.0058ca7d.mp3";